import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award } from "lucide-react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { isTopRated } from "@/components/Stars";
import { HOME } from "@/constants/testIds";

export const TopRatedRow = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/products").then(({ data }) => setItems(
      data.filter((p) => isTopRated(p.rating)).sort((a, b) => b.rating.average - a.rating.average || b.rating.count - a.rating.count).slice(0, 4),
    )).catch(() => {});
  }, []);
  if (!items.length) return null;
  return (
    <section data-testid={HOME.topRatedRow} className="max-w-7xl mx-auto px-6 lg:px-10 pt-20">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#E06D44] font-semibold"><Award size={14} className="text-[#F2B544]" /> Top rated</p>
          <h2 className="font-heading mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight">Pets can't stop raving</h2>
          <p className="mt-2 text-stone-600">4.5 stars or more from at least 3 real reviews.</p>
        </div>
        <Link to="/shop?top=1" data-testid={HOME.topRatedAll} className="text-sm font-semibold underline underline-offset-4 hover:text-[#E06D44] transition-colors">See all top rated</Link>
      </div>
      <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {items.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
      </div>
    </section>
  );
};
